<div class="spec">
  <span
    class="spec__key"
    *ngIf="key"
    >{{ key }}</span
  >
  <span
    class="spec__value"
    *ngIf="value"
    >{{ value }}</span
  >
</div>
